import constants from './MobileFormsConstants';
import listService from "../../service/ListService";
import Immutable        from 'immutable';
import mobileLoadService from "../../service/mobile/MobileLoadService";
import util from '../../service/util/Util';
import mobileConstants from "../../mobile/commons/MobileFormsConstants";
import mobileListService from '../../service/mobile/MobileListService';
import eventBus from "EventBus";
class MobileGeneralFunctions {

    cleanContainer(el) {
        try {
            if(el){
                let canvasGroup = el.querySelector('canvas');

                if (canvasGroup) {
                    canvasGroup.parentNode.removeChild(canvasGroup);
                }

                el.removeChild(el.querySelector(`#${el.id}>div.size-handle-top`));
                el.removeChild(el.querySelector(`#${el.id}>div.size-handle-left`));
                el.removeChild(el.querySelector(`#${el.id}>div.size-handle-right`));
                el.removeChild(el.querySelector(`#${el.id}>div.size-handle-bottom`));
                el.removeChild(el.querySelector(`#${el.id}>div.ui-resizable-handle.ui-resizable-nw`));
                el.removeChild(el.querySelector(`#${el.id}>div.ui-resizable-handle.ui-resizable-ne`));
                el.removeChild(el.querySelector(`#${el.id}>div.ui-resizable-handle.ui-resizable-sw`));
                el.removeChild(el.querySelector(`#${el.id}>div.ui-resizable-handle.ui-resizable-se`));
            }
        }catch(error){
            console.log("cleanGroupError: " + error);
        }
        
    }

    objectInMobileDesign(id){
        return listService.getMobileObject(id) && listService.controlHasSection(id);
    }

    deleteElementIntoMobileObject(id){
      
        listService.deleteMobileObjectbyId(id);
        
    }

    addedNewObjectToDesktopCanvas(control){
        if(listService.timesWizardCompleted){
            mobileLoadService._addObject(control, true, false, '');
            eventBus.trigger(constants.EV_VALIDATE_PULSE_ICON_EVENT);
        }
    }

    isControlNew(attributes){
        let defaultValue = !listService.mobileGetWizardCompleted;
        return attributes && attributes._isNew ? util.isTrue(attributes._isNew) : defaultValue;
    }

    GetDefaultFontByFactoryKey(factoryKey, id){

        let defaultFont = constants.FONT_DEFAULT_10;
        if (!factoryKey) { return defaultFont; }
        let controlFactoryKey = factoryKey;

        let fontSize = null;

        if(id){
           let mobileControl = mobileListService.getMobileControl(id);
           if(mobileControl){
                fontSize = mobileControl.model.get("fontSize");
                defaultFont = fontSize || defaultFont;

                let wizardObject = listService.getMobileObject(id);

                if(wizardObject.attributes.fontSize !== defaultFont){
                    wizardObject.attributes.fontSize = defaultFont;
                    listService.updateMobileObject(id, wizardObject);
               }
           }
        }

        if(!fontSize){
            const getControlGeneralFontSize =  (key) => {
                let controlStyle =  listService.getMobileStyleByKey(key);
                return controlStyle ? controlStyle.fontSize : defaultFont;
            };

        
            if (constants.TEXTS_FACTORY_KEYS.includes(controlFactoryKey)) {
                fontSize = getControlGeneralFontSize(constants.TEXT_FACTORY_KEY);
                defaultFont = fontSize || constants.FONT_DEFAULT_10;
            } else if (constants.LINK_FACTORY_KEY === controlFactoryKey) {
                fontSize = getControlGeneralFontSize(controlFactoryKey);
                defaultFont = fontSize || constants.FONT_DEFAULT_10;
            } else if (constants.INPUTS_FACTORY_KEYS.includes(controlFactoryKey)) {
                fontSize = getControlGeneralFontSize(constants.TEXT_INPUT_FACTORY_KEY);
                defaultFont = fontSize|| constants.FONT_DEFAULT_10;
            } else if (constants.BUTTONS_FACTORY_KEYS.includes(controlFactoryKey)) {
                fontSize = getControlGeneralFontSize(constants.BUTTON_FACTORY_KEY);
                defaultFont = fontSize || constants.FONT_DEFAULT_10;
            } else if (constants.CHECKBOXS_FACTORY_KEYS.includes(controlFactoryKey)) {
                fontSize = getControlGeneralFontSize(constants.CHECKBOX_FACTORY_KEY);
                defaultFont = fontSize|| constants.FONT_DEFAULT_10;
            } else if (constants.TABLE_FACTORY_KEY === controlFactoryKey) {
                fontSize = getControlGeneralFontSize(constants.TABLE_FACTORY_KEY);
                defaultFont = fontSize || constants.FONT_DEFAULT_10;
            } else if(constants.SMALL_TEXT_FACTORY_KEY === controlFactoryKey){
                fontSize = getControlGeneralFontSize(constants.SMALL_TEXT_FACTORY_KEY);
                defaultFont = fontSize|| constants.FONT_DEFAULT_8;
            } else if(constants.LARGE_HEADING_FACTORY_KEY === controlFactoryKey){
                fontSize = getControlGeneralFontSize(constants.LARGE_HEADING_FACTORY_KEY);
                defaultFont = fontSize|| constants.FONT_DEFAULT_20;
            } else if(constants.MEDIUM_HEADING_FACTORY_KEY === controlFactoryKey) {
                fontSize = getControlGeneralFontSize(constants.MEDIUM_HEADING_FACTORY_KEY);
                defaultFont = fontSize || constants.FONT_DEFAULT_18;
            } else if(constants.SECTION_FACTORY_KEY === controlFactoryKey) {
                fontSize = getControlGeneralFontSize(constants.SECTION_FACTORY_KEY);
                defaultFont = fontSize || constants.MIN_SECTION_FONTSIZE;
            } else if(constants.SMALL_HEADING_FACTORY_KEY === controlFactoryKey) {
                fontSize = getControlGeneralFontSize(constants.SMALL_HEADING_FACTORY_KEY);
                defaultFont = fontSize || constants.FONT_DEFAULT_14;
            } else if(constants.SECTION_FACTORY_KEY === controlFactoryKey) {
                fontSize = getControlGeneralFontSize(constants.SECTION_FACTORY_KEY);
                defaultFont = fontSize || constants.FONT_DEFAULT_18;
            } else if(constants.LINK_FACTORY_KEY === controlFactoryKey) {
                fontSize = getControlGeneralFontSize(constants.LINK_FACTORY_KEY);
                defaultFont = fontSize || constants.FONT_DEFAULT_10;
            }
        }
       return defaultFont;
    }

    GetDefaultMarginByFactoryKey(factoryKey){
      
        const getControlGeneralMargin = (key) => {
            let controlStyle = listService.getMobileStyleByKey(key);
            return controlStyle;
        };

        let style = null;
        if (constants.MARGIN_KEY === factoryKey) {
            style = getControlGeneralMargin(constants.MARGIN_KEY);

            if(style){
                style.marginSize = style.marginSize || constants.MARGIN_DEFAULT_10;
                style.defaultMargin = style.defaultMargin || constants.DEFAULT_MARGIN;
            }else{
                style = {marginSize: constants.MARGIN_DEFAULT_10, defaultMargin: constants.DEFAULT_MARGIN};
            }
        }
        return style;
    }

    getFontByFactoryKey(factoryKey) {
        return this.pixelToVH(this.GetDefaultFontByFactoryKey(factoryKey).toString());
    }


    pixelToVH(value) {
        return `${(100 * parseInt(value)) / window.innerHeight}vh`;
    }

    getWorkflowStages(){
        let workFlowStages = listService.getWorkflowStages(true, true).map(stage => { return { "optionId" : stage.id, "optionName" : stage.model.get("name")} });
        return workFlowStages && workFlowStages.size ? workFlowStages.toArray() : [];
    }

    getWorkflowRoles(){
        let workFlowRoles = listService.getWorkflowRoles(true, true).map(role => { return { "optionId" : role.id, "optionName" : role.name} });
        return workFlowRoles && workFlowRoles.size ? workFlowRoles.toArray() : [];
    }

    SetCurrentStep(mobileSetting){

        listService.iniMobileGlobalSettings(constants.MOBILE_DEFAULT_SETTINGS);
        listService.mobileCurrentStep = listService._userSettings.get('_maShGS') === 'false' ? constants.MOBILE_FIRST_STEP : constants.MOBILE_DEFAULT_STEP;

        if(mobileSetting && mobileSetting.Settings && mobileSetting.Settings.CurrentStep){
            const stepValueFromXml = mobileSetting.Settings.CurrentStep._value;
            if (stepValueFromXml){
                listService.mobileCurrentStep = parseInt(stepValueFromXml);
                let temporalCurrentStep = listService._mobileSettings.find(s => s.name === constants.NAME_CURRENT_STEP);
                if(temporalCurrentStep){
                    temporalCurrentStep.value = parseInt(stepValueFromXml);
                }
            }
        }
    }


    SetGlobalStyles(mobileForm) {

        listService.iniMobileStyle(constants.MOBILE_DEFAULT_FONTS);

        if (mobileForm && mobileForm.Settings && mobileForm.Settings.MobileGlobalStyles  && mobileForm.Settings.MobileGlobalStyles.ControlStyle) {

            let stylesFromXml = Array.isArray(mobileForm.Settings.MobileGlobalStyles.ControlStyle) ?
                mobileForm.Settings.MobileGlobalStyles.ControlStyle :
                [mobileForm.Settings.MobileGlobalStyles.ControlStyle];

            let stylesFromLocal = listService.mobileStyles();

            if (stylesFromLocal) {
                stylesFromLocal.forEach( (style, key ) => {

                    let controlStyle = stylesFromXml.filter( style => style.factoryKey === key );

                    if(controlStyle && controlStyle.length){
                        style.fontSize = controlStyle[0].fontSize;

                        if(controlStyle[0].factoryKey === constants.MARGIN_KEY){
                            style.marginSize = controlStyle[0].marginSize;
                            style.defaultMargin = controlStyle[0].defaultMargin;
                        }
                     }
                });
            }
        }
    }

    getMaxColumnHeigth(pageId, mainColumn){
        const column = listService.getColumn(pageId, mainColumn);
        let maxHeight = 0;
        const heightRisk = constants.SECION_HEIGHT_RISK; //We need to assume some height risk in pixels to cover possible gaps on column height calculation

         if(mainColumn === 0){
             if(listService._mobileSections && listService._mobileSections.size && column){
                 listService._mobileSections
                 .filter(section => section.pageId && section.pageId === pageId && section.columnId === column.id)
                 .forEach( (section) => {
                     let controls = listService.getMobileObjectsBySectionId(section.id);
                     if(controls && controls.size){
                         maxHeight = maxHeight + constants.MIN_SECTION_HEIGHT;
                         controls.forEach( (control) => {
                            const object = listService.getObject(control.id);
                            const objectHeight = parseInt(object.model.get('height'));
                            if(object.model.get('factoryKey') ==='control_group'){
                                maxHeight = maxHeight + this.getGroupHeight(object);
                             }else{
                                maxHeight = maxHeight + objectHeight;
                             }
                             for (let property in control.margins) {
                                 if ( (property === 'top' || property === 'bottom') && control.margins.hasOwnProperty(property)) {
                                     maxHeight = maxHeight +  parseInt(control.margins[property]);
                                 }
                             }
                         });
                     }
                 });
             }
         }else{
             if(column.sections && column.sections.size > 0){
                 column.sections.forEach( (section) => {
                     let controls = listService.getMobileObjectsBySectionId(section.id);
                     if(controls && controls.size){
                         maxHeight = maxHeight + constants.MIN_SECTION_HEIGHT;
                         controls.forEach( (control) => {
                             const object = listService.getObject(control.id);
                             const objectHeight = parseInt(object.model.get('height'));
                             if(object.model.get('factoryKey') ==='control_group'){
                                maxHeight = maxHeight + this.getGroupHeight(object);
                             }else{
                                maxHeight = maxHeight + objectHeight;
                             }
                             for (let property in control.margins) {
                                 if ( (property === 'top' || property === 'bottom') && control.margins.hasOwnProperty(property)) {
                                     let margin = parseInt(control.margins[property]) === 0 ? 5 : parseInt(control.margins[property]);
                                     maxHeight = maxHeight +  margin;
                                 }
                             }
                         });
                     }
                 });
             }
         }

         return maxHeight + heightRisk;
     }

     getGroupHeight(controlGroup){
        if(controlGroup && controlGroup.model.get('childList').length){
            let mobileObject = listService.getMobileObject(controlGroup.model.get('id'));
            let mobileObjectMargins = mobileObject.margins;
            const marginTop = mobileObjectMargins.top ? parseInt(mobileObjectMargins.top) : 0;
            const marginBottom = mobileObjectMargins.bottom ? parseInt(mobileObjectMargins.bottom) : 0;
            const childList = controlGroup.model.get('childList');
            let headerSize = 0;
            let itemsSize = 0;
            let height = 0;
            childList.forEach(item => {                
                itemsSize += parseInt(item.get('height'));
            });
            const showGroupHeader = controlGroup.model.get('hasTitle');
            const groupHeaderHeight = parseInt(controlGroup.model.get('titleHeight'));
            if (util.isTrue(showGroupHeader) && !isNaN(groupHeaderHeight)) {
                headerSize = groupHeaderHeight + 10;
            } 
            height +=headerSize;
            height +=itemsSize;
            return height + parseInt(marginTop) + parseInt(marginBottom);
        }
     }

    getMainColumn(pageId, twoColumns){
        let mainColumn = 0;
        let maxHeight  = 0;
        let maxColumn1 = 0;
        let maxColumn2 = 0;
        if( twoColumns ){
           maxColumn1 = this.getMaxColumnHeigth(pageId, mobileConstants.FIRST_COLUMN_ORDER);
           maxColumn2 = this.getMaxColumnHeigth(pageId, mobileConstants.SECOND_COLUMN_ORDER);
           mainColumn = maxColumn2 > maxColumn1 ? 2 : 1 ;
           maxHeight = maxColumn2 > maxColumn1 ? maxColumn2 : maxColumn1 ;
        }else{
            mainColumn = 1;
            maxHeight = this.getMaxColumnHeigth(pageId, mobileConstants.CURRENT_COLUMN_ORDER);
        }
        return {mainColumn, maxHeight};
    }

    reorganizeIndex(pageId, mainColumn){
        let newIndex = 1;
        let newindexes  = Immutable.Map();
        let column = listService.getColumn(pageId, mainColumn);

        if (column && column.sections) {
            column.sections
                .sortBy((section) => section.order)
                .forEach( (section) => {
                    newindexes = newindexes.set(section.id, {index: newIndex});
                    newIndex++;
                });

            const secondColumn = mainColumn === constants.SECOND_COLUMN_ORDER ? constants.FIRST_COLUMN_ORDER : constants.SECOND_COLUMN_ORDER;
            column = listService.getColumn(pageId, secondColumn);
            column.sections
                .sortBy((section) => section.order)
                .forEach( (section) => {
                    newindexes = newindexes.set(section.id, {index: newIndex});
                    newIndex++;
                });
        }
        
        return newindexes;
    }

    getColumnNumberBySection(sectionId, pageId){
        var _column = listService.getColumn(pageId, 2);
        var _colNumber;
        if (typeof _column !== 'undefined' && _column.sections){
            _colNumber = _column.sections.filter(section => section.id === sectionId);
        }

        return typeof _colNumber !== 'undefined' && _colNumber.size > 0 ? 2 : 1;
    }

    getDefaultHeightByFactoryKey(factoryKey){
        switch(factoryKey){
            case mobileConstants.TABLE_FACTORY_KEY:
               return mobileConstants.DEFAULT_TABLE_HEIGHT;
            case mobileConstants.WEBSIGNATURE_FACTORY_KEY:
               return mobileConstants.DEFAULT_WEBSIGNATURE_HEIGHT;
             default:
               return mobileConstants.DEFAULT_HEIGHT;
        }
     }

     isControlInGroup(control){
         return control.groupId;
     }

     adjustControlMargins(control){
        let margins = control.margins;
        margins.left = 5;
        margins.right = 5;
        if(control.order === 1 && margins.top === 0){
            margins.top = 5;
        }
        if(control.order === listService.countMobileObjectsBySectionId(control.sectionId) && margins.bottom === 0){
            margins.bottom = 5;
        }

        return margins;
    }

}

const utilMobile = new MobileGeneralFunctions();
export default utilMobile;
